import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { getLocale } from 'lib/utils/getLocale'

import Link from 'components/Link'

const UserReviewInfoSection = () => {
    const { t, i18n } = useTranslation('editProfile')

    return (
        <div className="user-review-info-section">
            <p>
                <Trans i18nKey="editProfile:details.reviewInfo.description.paragraph1">
                    <Link
                        to={`${getLocale(i18n.language)}/ota-yhteytta`}
                        trackName="customerService"
                    >
                        ota yhteyttä asiakaspalveluumme
                    </Link>.
                </Trans>
            </p>
            <p>
                <Trans i18nKey="editProfile:details.reviewInfo.description.paragraph2">
                    <Link
                        to={t('editProfile:details.reviewInfo.description.privacyInfoLink')}
                        trackName="privacyInfo"
                        target="_blank"
                    >
                        Tietosuoja
                    </Link>.
                </Trans>
            </p>
        </div>
    )
}

export default UserReviewInfoSection
